import type EnType from '../en-US/search';

export default {
  'search.SearchBar.label': '検索',
  'search.SearchModal.errorScreen.helpText': 'ネットワーク接続を確認してください',
  'search.SearchModal.errorScreen.titleText': '検索結果の取得に失敗しました',
  'search.SearchModal.footer.closeKeyAriaLabel': 'エスケープキー',
  'search.SearchModal.footer.closeText': '閉じる',
  'search.SearchModal.footer.navigateDownKeyAriaLabel': '下矢印キー',
  'search.SearchModal.footer.navigateText': '移動',
  'search.SearchModal.footer.navigateUpKeyAriaLabel': '上矢印キー',
  'search.SearchModal.footer.searchByText': '検索',
  'search.SearchModal.footer.selectKeyAriaLabel': 'エンターキー',
  'search.SearchModal.footer.selectText': '選ぶ',
  'search.SearchModal.noResultsScreen.noResultsText': '見つかりませんでした',
  'search.SearchModal.noResultsScreen.reportMissingResultsLinkText': '報告する',
  'search.SearchModal.noResultsScreen.reportMissingResultsText': 'よりよい検索結果がありますか?',
  'search.SearchModal.noResultsScreen.suggestedQueryText': '次の検索を試す:',
  'search.SearchModal.placeholder': 'ドキュメントを検索',
  'search.SearchModal.searchBox.cancelButtonText': 'キャンセル',
  'search.SearchModal.searchBox.resetButtonTitle': 'クリア',
  'search.SearchModal.startScreen.favoriteSearchesTitle': 'お気に入り',
  'search.SearchModal.startScreen.noRecentSearchesText': '最近の検索履歴はありません',
  'search.SearchModal.startScreen.recentSearchesTitle': '最近の検索',
  'search.SearchModal.startScreen.removeFavoriteSearchButtonTitle': 'この検索をお気に入りから削除',
  'search.SearchModal.startScreen.removeRecentSearchButtonTitle': 'この検索を履歴から削除',
  'search.SearchModal.startScreen.saveRecentSearchButtonTitle': 'この検索をお気に入りに追加',
} satisfies typeof EnType;
